import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://musica-pronta.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Get the Math Ready Pack',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group inline-flex items-center justify-center gap-3 rounded-lg bg-orange-600 px-8 py-5 text-center text-sm font-bold uppercase tracking-[0.08em] leading-none text-white shadow-sm transition-colors duration-200 hover:bg-orange-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-600 focus-visible:ring-offset-2 sm:px-10 sm:text-base ${className}`} data-id="element-42" data-mp="qkagr5ve53tw">
      <span data-id="element-43" data-mp="15ahoornrv4gc">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-44" data-mp="15b18yf0wa4xj" />
    </a>;
}